import { Controller } from '@hotwired/stimulus';
import fieldsForUtils from '../../concerns/fields_for_utils';

export default class extends Controller {
  static targets = ['order', 'destroyButton', 'fields'];

  initialize() {
    fieldsForUtils(this);
    this.reorder();
  }

  destroyHandler(e) {
    e.preventDefault();
    this.destroy();
    this.reorder(e);
    this.removeController();
  }

  reorder(closeEvent = null) {
    const forms = document.querySelectorAll('[data-transport-flight-cargo-target="fields"]');
    this.reorderForms(forms, closeEvent);
  }

  removeController() {
    this.element.dataset.controller = null;
  }
}
